import { useU3401Context } from '../U3401Context';
import { NS } from '../U3401';
import { U3401_LU_CODE, luHandleAppiError } from '../U3401Service';
import U340xKpiStandaloneContainer from '../../u340xKpiShared/components/U340xKpiStandaloneContainer';

function U3401StandaloneScreen() {
  const { initLU } = useU3401Context();

  return (
    <U340xKpiStandaloneContainer
      logicalUnitCode={U3401_LU_CODE}
      nameSpace={NS}
      initLU={initLU}
      luHandleAppiError={luHandleAppiError}
    />
  );
}

export default U3401StandaloneScreen;
